var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"node"},[_vm._m(0),_c('div',{staticClass:"node-footer"},[_c('div',{staticClass:"btn"},[_c('insert-button',{on:{"insertNode":type => _vm.$emit('insertNode', type)}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"node-body"},[_c('div',{staticClass:"process-end"},[_vm._v(" 流程开始 ")])])
}]

export { render, staticRenderFns }